import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dimmer,
  Grid,
  Label,
  Loader,
  Segment,
} from 'semantic-ui-react';

import { fetchM } from '../../../actions/fetchM';
import { checkSvgFormatValid, displaySVG } from '../../../utils/siteplanSVG';
import LoadImage from '../../../components/LoadImage';

export default class UploadSiteplanForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      uploads: [null, null],
      name: '',
    };
    this.uploadFile = {};
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  submit(url, opts = {}) {
    const { store } = this.context;
    return this.setLoading(true)
      .then(() => store.dispatch(fetchM(url, opts)))
      .then(res => res.json())
      .then(result => this.setLoading(false)
        .then(() => this.resetFiles())
        .then(() => result))
      .catch(err => this.setLoading(false)
        .then(() => this.resetFiles())
        .then(() => Promise.reject(err)));
  }
  resetFiles() {
    // temporary fix for upload modal not closing
    this.setState({
      uploads: [null, null],
    });
  }
  handleSubmit = (event) => {
    event.preventDefault();
    if (this.state.uploads.filter(u => u !== null).length > 1) {
      const formData = new FormData(this.form);
      this.state.uploads.forEach((upload, idx) => {
        formData.append(`files_${idx}`, upload.file);
      });
      formData.append('name', this.state.name);
      if (this.props.onSubmit) {
        this.props.onSubmit(event, formData);
      }
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        if (this.props.onChange) {
          this.props.onChange(true);
        }
      });
    }
  }
  handleOnChange = (type) => {
    if (this.uploadFile[type]) {
      const files = Array.prototype.slice.call(this.uploadFile[type].files);
      this.uploadFile[type].value = null;
      if (window.FileReader) {
        files.forEach((file) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const { uploads } = this.state;
            const name = file.name.substring(0, file.name.length - 4);
            const src = reader.result;
            if (type === 'svg') {
              if (checkSvgFormatValid(src)) {
                uploads[0] = {
                  file,
                  name,
                  src,
                };
              } else {
                uploads[0] = null;
              }
            } else {
              uploads[1] = {
                file,
                name,
                src,
              };
            }
            this.setState({ uploads, name }, () => {
              this.handleCheckChanges();
            });
          };
          if (type === 'svg') {
            reader.readAsText(file);
          } else {
            reader.readAsDataURL(file);
          }
        });
      }
    }
  }
  handleRemove = (event, type) => {
    event.preventDefault();
    const { uploads } = this.state;
    const idx = type === 'svg' ? 0 : 1;
    uploads[idx] = null;
    this.setState({ uploads });
  }
  handleAddFile = (event, type) => {
    event.preventDefault();
    if (this.uploadFile[type]) {
      this.uploadFile[type].click();
    }
  }
  render() {
    const { uploads } = this.state;
    let svgUrl;
    let svgImgUrl;
    if (uploads.length > 0) {
      if (uploads[0] && uploads[0].src) {
        svgUrl = uploads[0].src;
      }
      if (uploads[1] && uploads[1].src) {
        svgImgUrl = uploads[1].src;
      }
    }
    return (
      <form
        encType="multipart/form-data"
        onSubmit={this.handleSubmit}
        name="uploadSiteplan"
        ref={(ref) => { this.form = ref; }}
      >
        <input
          ref={(ref) => { this.uploadFile.svg = ref; }}
          type="file"
          onChange={() => this.handleOnChange('svg')}
          accept="image/svg+xml"
          style={{ display: 'none' }}
        />
        <input
          ref={(ref) => { this.uploadFile.image = ref; }}
          type="file"
          onChange={() => this.handleOnChange('image')}
          accept="image/gif, image/jpeg, image/png"
          style={{ display: 'none' }}
        />
        <Grid verticalAlign="middle" stackable>
          <Grid.Row columns="equal">
            <Grid.Column only="computer" />
            <Grid.Column>
              <Grid verticalAlign="middle" columns="equal">
                <Grid.Column>
                  <Button
                    fluid
                    compact
                    positive
                    content="Upload" icon="cloud upload"
                    loading={this.state.loading}
                    onClick={this.handleSubmit}
                    disabled={
                      uploads.filter(u => u !== null).length < 2 || this.state.loading}
                  />
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid stackable doubling columns={2}>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader indeterminate inline="centered">Uploading</Loader>
          </Dimmer>
          <Grid.Column>
            {
              svgUrl ? (
                <Segment secondary>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: displaySVG(svgUrl),
                    }}
                  />
                  <Label
                    as="a"
                    corner
                    color="red"
                    icon="delete"
                    disabled={this.state.loading}
                    onClick={e => this.handleRemove(e, 'svg')}
                  />
                </Segment>
              ) : (
                <Segment secondary>
                  <Button
                    fluid
                    compact
                    primary
                    icon="add"
                    content="SVG"
                    onClick={e => this.handleAddFile(e, 'svg')}
                    disabled={this.state.loading}
                  />
                </Segment>
              )
            }
          </Grid.Column>
          <Grid.Column>
            {
              svgImgUrl ? (
                <Segment secondary>
                  <LoadImage fluid src={svgImgUrl} />
                  <Label
                    as="a"
                    corner
                    color="red"
                    icon="delete"
                    disabled={this.state.loading}
                    onClick={e => this.handleRemove(e, 'image')}
                  />
                </Segment>
              ) : (
                <Segment secondary>
                  <Button
                    fluid
                    compact
                    primary
                    icon="add"
                    content="Image"
                    onClick={e => this.handleAddFile(e, 'image')}
                    disabled={this.state.loading}
                  />
                </Segment>
              )
            }
          </Grid.Column>
          {
            (svgUrl && svgImgUrl) ? (
              <Grid.Column>
                <Segment>
                  <b>Preview</b>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: displaySVG(svgUrl, svgImgUrl),
                    }}
                  />
                </Segment>
              </Grid.Column>
            ) : null
          }
        </Grid>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Projects/Siteplan/SiteplanForm.jsx